var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MapConsumer',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var path = ref.path;
return [_c('path',{style:(_vm.computedStyle),attrs:{"d":path(_vm.data)},on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp,"click":_vm.onMouseUp}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }